/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const Combine = [
  ["path", { d: "M14 3a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1" }],
  ["path", { d: "M19 3a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1" }],
  ["path", { d: "m7 15 3 3" }],
  ["path", { d: "m7 21 3-3H5a2 2 0 0 1-2-2v-2" }],
  ["rect", { x: "14", y: "14", width: "7", height: "7", rx: "1" }],
  ["rect", { x: "3", y: "3", width: "7", height: "7", rx: "1" }]
];

export { Combine as default };
//# sourceMappingURL=combine.js.map
